import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onEmergencyStop }) => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: 'Client Management',
      description: 'Add, edit, or manage client profiles',
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      path: '/client-management'
    },
    {
      title: 'Exercise Database',
      description: 'Manage exercise library and media',
      icon: 'Database',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
      path: '/exercise-database'
    },
    {
      title: 'Training Plans',
      description: 'Create and modify training programs',
      icon: 'FileText',
      color: 'text-wellness',
      bgColor: 'bg-wellness/10',
      path: '/training-plan-builder'
    },
    {
      title: 'Emergency Stop',
      description: 'Stop all active sessions immediately',
      icon: 'AlertTriangle',
      color: 'text-destructive',
      bgColor: 'bg-destructive/10',
      action: onEmergencyStop,
      variant: 'destructive'
    }
  ];

  const handleActionClick = (action) => {
    if (action?.path) {
      navigate(action?.path);
    } else if (action?.action) {
      action?.action();
    }
  };

  return (
    <div className="bg-surface border border-border rounded-xl p-6 shadow-md hidden">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground mb-2">Quick Actions</h2>
        <p className="text-sm text-muted-foreground">
          Access key trainer functions and emergency controls
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {quickActions?.map((action, index) => (
          <Button
            key={index}
            variant={action?.variant || "outline"}
            size="lg"
            onClick={() => handleActionClick(action)}
            className="h-auto p-4 breathing-focus haptic-button justify-start"
          >
            <div className="flex items-center space-x-4 w-full">
              <div className={`w-12 h-12 ${action?.bgColor} rounded-xl flex items-center justify-center flex-shrink-0`}>
                <Icon name={action?.icon} size={24} className={action?.color} />
              </div>
              <div className="text-left flex-1">
                <p className="font-semibold text-foreground mb-1">{action?.title}</p>
                <p className="text-sm text-muted-foreground">{action?.description}</p>
              </div>
              <Icon name="ChevronRight" size={20} className="text-muted-foreground flex-shrink-0" />
            </div>
          </Button>
        ))}
      </div>
      {/* Additional Quick Tools */}
      <div className="mt-6 pt-6 border-t border-border ">
        <h3 className="font-medium text-foreground mb-4">Quick Tools</h3>
        <div className="flex flex-wrap gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/client-management?action=new')}
            className="breathing-focus"
          >
            <Icon name="UserPlus" size={16} className="mr-2" />
            New Client
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/exercise-database?action=import')}
            className="breathing-focus"
          >
            <Icon name="Upload" size={16} className="mr-2" />
            Import Exercises
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/training-plan-builder?action=template')}
            className="breathing-focus"
          >
            <Icon name="Copy" size={16} className="mr-2" />
            Plan Template
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;